import firebase from 'firebase/app';

import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions'
import 'firebase/storage'

export default class Fire {

  // Initialize Firebase
  static init() {
    const cfg = require('../keys/firebase')
    firebase.initializeApp(cfg.default);
  }

  static batch() {
    return this.store().batch()
  }

  // Retrieve base firestore
  static store() {
    return firebase.firestore()
  }

  static collection(col: string) {
    return this.store().collection(col)
  }

  // Retrieve base auth
  static auth() {
    return firebase.auth()
  }

  // Retrieve base storage
  static storage() {
    return firebase.storage()
  }

  // Reauth
  static async reauthEmail(email: string, password: string) {
    const user = Fire.auth().currentUser
    if (!user)
      return null;
    const credential = firebase.auth.EmailAuthProvider.credential(email, password);
    return user.reauthenticateWithCredential(credential)
  }

  // Retrieve base functions
  static async cloud(name: string, data: any) {
    const callable = firebase.functions().httpsCallable(name)
    const res = await callable(data)
    return res.data
  }

  // Increment a field
  static increment(nb: number) {
    return firebase.firestore.FieldValue.increment(nb);
  }

  // Upload a file to Storage
  static async uploadFile(location: string, uri: string) {
    // Retrieve Blob
    const res = await fetch(uri)
    const blob = await res.blob()
    // Send it to Firebase Storage
    const store = Fire.storage().ref()
    const ref = store.child(location)
    const uploaded = await ref.put(blob)
    // Retrieve persistent URL
    return await uploaded.ref.getDownloadURL()
  }

  static async getGlobalStats() {
    const ref = Fire.store().collection('stats').doc('generic')
    const element = await Fire.doc(ref)
    return element || {}
  }

  // Shortcuts
  static async doc(ref: any) {
    const doc = await ref.get()
    if (!doc.exists)
      return null
    return {
      id: doc.id,
      ...doc.data()
    }
  }

  static async list(ref: any) {
    const arr: any[] = []
    const snap = await ref.get()
    snap.forEach((doc: any) => {
      if (!doc.exists)
        return null
      arr.push({
        id: doc.id,
        ...doc.data()
      })
    })
    return arr
  }

  // Shortcuts
  
  static set(collection: string, id: string, data: any) {
    return Fire.store().collection(collection).doc(id).set(data)
  }
  static update(collection: string, id: string, data: any) {
    return Fire.store().collection(collection).doc(id).update(data)
  }

  // Dates

  // Retrieve timestamp for given date (for test purpopses only)
  static getTimeFor(date: Date) {
    return firebase.firestore.Timestamp.fromDate(date)
  }

  // Retrieve date from timestamp
  static getDateFor(timestamp: any){
    if (!timestamp.toDate)
      return new Date(timestamp)
    return timestamp.toDate()
  }
}